import { BackendResponseFormat } from "../utils/fetch";
import { BackendError } from "./BackendError";

export class ForbiddenError extends BackendError {
  constructor(responseBody: BackendResponseFormat<unknown> | string) {
    super(403, responseBody);
    this.name = "ForbiddenError";
  }
}
